export interface StatusDotProps {
  label?: string;
  live?: boolean;
  className?: string;
  'data-testid'?: string;
}

/**
 * Live / status indicator with optional label (reference: LIVE PREVIEW header).
 */
export function StatusDot({
  label = 'Live',
  live = true,
  className = '',
  'data-testid': dataTestId,
}: StatusDotProps) {
  return (
    <span
      data-testid={dataTestId ?? 'design-system-status-dot'}
      className={`ds-status-live ${className}`.trim()}
    >
      <span
        aria-hidden
        className={`h-2 w-2 rounded-full ${live ? 'bg-success shadow-glow-success' : 'bg-muted'}`}
      />
      {label}
    </span>
  );
}
